// extracted by mini-css-extract-plugin
export default {"h2":"BJeFnlNddJKEFK4PA5Vp","bold":"LgniFo6XjZn7ZasZhh5F","pink":"UHoN3Rv2XK0JGie2QhaN"};